module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('back-button'), _vm._v(" "), _c('swipe', {
    staticClass: "swipe-fullscreen",
    attrs: {
      "options": _vm.swipeOptions
    }
  }, [_c('swipe-item', {
    staticStyle: {
      "background": "#EA5A49"
    }
  }), _vm._v(" "), _c('swipe-item', {
    staticStyle: {
      "background": "#44CC00"
    }
  }), _vm._v(" "), _c('swipe-item', {
    staticStyle: {
      "background": "#FFBD17"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-27997cb5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/components/FullScreen.vue
// module id = 27
// module chunks = 0